import React, { Component } from 'react';
import "./footer.css";
import { Link } from "react-router-dom";
import {CopyrightText} from "./../../utils/constants";

export default class Footer extends Component {
  render() {
    return (
      <div className="footer full-width centered-text">
        <Link to="/">
          <img className="footer-icon" src="/images/km-logo-wide.png" />
        </Link>
        <div className="full-width centered-text">
          <a target="_blank" href="https://www.instagram.com/katmedinawriter">
            <img className="footer-social-icon" src="/images/icon-instagram.png" />
          </a>
          <a target="_blank" href="https://www.facebook.com/katmedinawriter">
            <img className="footer-social-icon" src="/images/icon-facebook.png" />
          </a>
          <a target="_blank" href="https://www.goodreads.com/book/show/62976241-the-joys-of-jet-lag?ac=1&from_search=true&qid=i2l3Bs4BqR&rank=1">
            <img className="footer-social-icon" src="/images/icon-goodreads.png" />
          </a>
        </div>
        <div className="full-width centered-text">
          <div className="footer-link">
            <Link to="/books">{'Books'}</Link>
          </div>
          <div className="footer-link">
            <Link to="/observations">{'Articles'}</Link>
          </div>
          <div className="footer-link">
            <Link to="/about">{'About'}</Link>
          </div>
          <div className="footer-link">
            <Link to="/contact">{'Contact'}</Link>
          </div>
          <div className="footer-link">
            <Link to="/speakingOps">{'Work With Me'}</Link>
          </div>
        </div>
        <div className="tiny-padding">
          <div style={{fontSize: '12px'}}>{CopyrightText}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js